module.exports = __webpack_public_path__ + "static/media/29.38ed38a2.jpg";